import { DHCP_CODE } from '../constants.ts';

export const determineIsDhcpOption43Enabled = (data: RemoteAccess) =>
  data.dhcpOptions?.length === 1;

export const determineDhcpType = (data: RemoteAccess) =>
  data.dhcpOptions?.[0]?.dhcpType ?? 'HEX';

export const determineDhcpValue = (data: RemoteAccess) =>
  data.dhcpOptions?.[0]?.dhcpValue ?? '';

type BuildDhcpOptions = {
  dhcpOption43Enabled: boolean;
  dhcpType?: DhcpTypes;
  dhcpValue?: string;
};

export const buildDhcpOptions = ({
  dhcpOption43Enabled,
  dhcpType,
  dhcpValue,
}: BuildDhcpOptions): DhcpOption[] =>
  dhcpOption43Enabled && dhcpValue
    ? [
        {
          dhcpCode: DHCP_CODE,
          dhcpType,
          dhcpValue,
        },
      ]
    : [];
